<template>
  <div id="activityList" :class="{selected: showSelected}">
    <template if="ticket">
      <div class="activity" :class="{read: notification.reads[0].hasRead > 0}">
        <div class="dot" @click="toggleRead(notification)"></div>
        <div class="details" @click="openActivity(notification)">
          <div class="preview">{{ getPreview(notification) }}</div>
          <div class="icon">
            <v-icon>{{ getIcon(notification) }}</v-icon>
          </div>
          <div class="date">{{ notification.created | dateTimeShorthand }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

  import ListItemMixin from '../mixins/listItemMixin.js' 

  export default {
    
    mixins: [ListItemMixin],
    
    data () {
      return {

      }
    },
    
    computed: {
      notification () {
        return this.$store.getters.notification(this.item);
      }
    },

    methods: {

      getPreview (notification) {
        return notification.preview;
      },

      getIcon (notification) {
        var action  = notification.action;
        var model   = notification.model;

        if      (model === 'ticket' && action === 'update.assignees.remove')  return 'mdi-account-remove';
        else if (model === 'ticket' && action === 'update.assignees.add')     return 'mdi-account-plus';
        else if (model === 'ticket' && action === 'update.status')            return 'mdi-traffic-light';
        else if (model === 'ticket' && action === 'update.tags.add')          return 'mdi-tag-plus';
        else if (model === 'ticket' && action === 'update.tags.remove')       return 'mdi-tag-remove';
        else if (model === 'ticket' && action === 'create')                   return 'mdi-ticket';
        else if (model === 'ticketComment' && action === 'create')            return 'mdi-forum';
        else if (model === 'ticketNote' && action === 'create')               return 'mdi-clipboard-text';
      },

      openActivity (item) {

        if (item.reads[0].hasRead === 0) {
          this.toggleRead(item);
        }
         
        this.routeRemoveQuery('activity');
        this.$router.push(item.route);
      },

      toggleRead (item) {
        if (this.lockout) return;
        this.lockout = true;

        this.$store.dispatch('notificationToggleRead', {
          notification: item
        })
        .then(data => {
          this.lockout = false;
        })
        .catch(e => {
          console.log(e);
          this.lockout = false;
          Toast.showError(e);
        });
      }

    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #activityList {
  
    .activity {
      @include fontPrimary500;
      position: relative;
      height: 70px;
      background: $active;
      transition: all .2s ease;

      .dot {
        top: 25px;
        left: 16px;
        position: absolute;
        background: $primary;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        cursor: pointer;
        
        transition: all .2s ease;
        transform: scale3d(1.1, 1.1, 1);
      }

      .details {
        
        user-select: none;
        border-bottom: $borderBlack12;
        position: absolute;
        top: 8px;
        left: 50px;
        right: 16px;
        bottom: 0;
        cursor: pointer;

        .preview {
          @include textEllipsis();

          position: absolute;
          top: 8px;
          left: 8px;
          right: 0px;
        }

        .icon {
          position: absolute;
          top: 15px;
          left: 2px;

          i {
            
            &:before {
              font-size: 20px;
            }
          }
        }

        .date {
          position: absolute;
          top: 30px;
          left: 32px;
          right: 0;
          font-size: 12px;
          color: $black54;
          @include fontPrimary500();

          transition: all .2s ease;
        }

      }

      &.read {
        background: #FFF;
      
        .dot {
          background: $black24;
          transform: scale3d(1, 1, 1);
        }

        .date {
          @include fontPrimary500();
        }
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/ActivityList.vue